module.exports = __webpack_public_path__ + "media/styles/images/png/eraser-teal-72ea6ede347ad93a1cd65fd6ca9bf555.png";